<mat-slide-toggle color="primary" [formControl]="allDayControl">
  {{ 'allDay' | i18nextCap }}
</mat-slide-toggle>
@if (allDayControl.value) {
  <mat-form-field>
    <mat-label>{{ 'date' | i18nextCap }} </mat-label>
    <input
      matInput
      [formControl]="singularDateControl"
      [matDatepicker]="datePicker"
    />
    <mat-datepicker-toggle matSuffix [for]="datePicker" />
    <mat-datepicker #datePicker />
  </mat-form-field>
} @else {
  <fo-date-time-input
    mainLabel="forms:startDate"
    timeLabel="forms:startingHour"
    [formControl]="startDateControl"
    [minTimeMinutes]="minTimeMinutes"
    [maxTimeMinutes]="maxTimeMinutes"
  />
  <fo-date-time-input
    mainLabel="forms:endDate"
    timeLabel="forms:endingHour"
    [formControl]="endDateControl"
    [minTimeMinutes]="minTimeMinutes"
    [maxTimeMinutes]="maxTimeMinutes"
  />
}
